import { apiClient, requiresAuth } from '../client';
import { Campus } from '../../types';

export const campusService = {
  getAllCampuses: async () => {
    console.log('[API] campusService.getAllCampuses - Fetching all campuses - START');
    try {
      return requiresAuth(async () => {
        console.log('[API] campusService.getAllCampuses - Making request to /campus');
        const response = await apiClient.get('/campus');
        console.log('[API] campusService.getAllCampuses - Response:', response);
        return response.data;
      });
    } catch (error) {
      console.error('[API] campusService.getAllCampuses - Error fetching campuses:', error);
      throw error;
    }
  },

  getCampusById: async (id: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get(`/campus/${id}`);
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.getCampusById - Error fetching campus ${id}:`, error);
      throw error;
    }
  },

  createCampus: async (campusData: Partial<Campus>) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.post('/campus', campusData);
        return response.data;
      });
    } catch (error) {
      console.error('[API] campusService.createCampus - Error creating campus:', error);
      throw error;
    }
  },

  updateCampus: async (id: string, campusData: Partial<Campus>) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.patch(`/campus/${id}`, campusData);
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.updateCampus - Error updating campus ${id}:`, error);
      throw error;
    }
  },

  deleteCampus: async (id: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.delete(`/campus/${id}`);
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.deleteCampus - Error deleting campus ${id}:`, error);
      throw error;
    }
  },

  disableCampus: async (id: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.patch(`/campus/disable/${id}`, {});
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.disableCampus - Error disabling campus ${id}:`, error);
      throw error;
    }
  },

  // User management for campuses
  getCampusUsers: async (campusId: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get(`/campus/${campusId}/users`);
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.getCampusUsers - Error fetching users for campus ${campusId}:`, error);
      throw error;
    }
  },

  assignUserToCampus: async (campusId: string, userId: string, schoolId?: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.post(
          `/campus/${campusId}/user/${userId}`,
          { school_id: schoolId }
        );
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.assignUserToCampus - Error assigning user ${userId} to campus ${campusId}:`, error);
      throw error;
    }
  },

  removeUserFromCampus: async (campusId: string, userId: string) => {
    try {
      return requiresAuth(async () => {
        const response = await apiClient.delete(
          `/campus/${campusId}/user/${userId}`
        );
        return response.data;
      });
    } catch (error) {
      console.error(`[API] campusService.removeUserFromCampus - Error removing user ${userId} from campus ${campusId}:`, error);
      throw error;
    }
  },
};
